import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import the styles
import { getData } from "utilities/common";
import { STILO } from "utilities/constants";

const CommonQuillEditor = ({
  value,
  disabled = false,
  onChange,
  allowImage = true,
  allowHeading = true,
  style = false,
  height = "400px",
}) => {
  const adminsMode = getData("adminsMode");
  const isStilo = JSON.parse(adminsMode) === STILO;
  const [editorHtml, setEditorHtml] = useState("");

  const handleChange = (html) => {
    setEditorHtml(html);
    onChange && onChange(html);
  };

  useEffect(() => {
    setEditorHtml(value);
  }, [value]);

  return (
    <div className="mb-4">
      <ReactQuill
        className="quill-text-editor"
        theme="snow"
        value={editorHtml}
        readOnly={disabled}
        onChange={handleChange}
        modules={{
          toolbar: {
            container: [
              allowHeading
                ? [{ header: [1, 2, 3, 4, 5, 6, false] }]
                : [{ header: [2, 3, 4, 5, 6, false] }], // Conditionally remove heading
              ["bold", "italic", "underline", "strike", "blockquote"],
              [{ list: "ordered" }, { list: "bullet" }],
              allowImage ? ["link", "image"] : ["link"],
              ["clean"],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ align: [] }],
            ],
          },
        }}
        style={
          isStilo && style
            ? {
                height: height,
                display: "flex",
                flexDirection: "column",
              }
            : undefined
        }
      />
    </div>
  );
};

export default CommonQuillEditor;
